import * as React from "react";
import {withRouter} from "react-router-dom"
import {connect} from 'react-redux';
import {Link} from "react-router-dom";

import classNames from "classnames";
import styles from './footer.module.scss';

import {IData} from "../../reducers/dataReducer"

import twitter from  '../../images/twitter.svg'
import facebook from  '../../images/facebook.svg'

interface State {}

interface parentProps {
  location: any;
}

interface StoreProps {
  data: IData;
}

interface DispatchProps {}

const mapStateToProps = state => {
  return {
    data: state.data,
  }
}

const mapDispatchToProps = dispatch => ({});

type Props = StoreProps & DispatchProps & parentProps

export class Footer extends React.Component<Props, State> {

  constructor(props) {
    super(props);

    this.state = {}
  }


  render() {

    let darktheme = false
    if (this.props.location.pathname === "/" || this.props.location.pathname === "/home")
      darktheme = true

    return <div className={classNames("container-fluid", {[`${styles.darktheme}`] : darktheme})}>
      <div className={styles.footerHolder}>
        <div className={styles.links} >
          <Link to="/contact">Contact</Link>
          <Link to="/tarieven">Tarieven</Link>
          <Link to="/voorwaarden">Regels en voorwaarden</Link>
          <Link to="/privacy-klachtenregeling">Privacy</Link>
        </div>
        {this.socials()}
      </div>
    </div>
  }

  socials() {
    return <div className={styles.socialHolder}>
      <a className={classNames(styles.social, styles.twitter)} target="_blank" href="https://twitter.com/DenOmmelanden"><img src={twitter}/></a>
      <a className={classNames(styles.social, styles.facebook)}  target="_blank" href="https://www.facebook.com/Fysiotherapie-Den-Ommelanden-405345179529736/"><img src={facebook}/></a>
    </div>
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));

